export default {
  methods: {
    blogCategoryLink(blogTag) {
      const formattedName = this.$formatUrlhelloBB(blogTag.name);
      return this.$utils.removeDoubleSlashes(process.env.APP_URL + '/blog/categorias/' + formattedName);
    }
  },
}
